import { globalAxios, backendVersion } from "@/axios-path.js";
// fetchFoodSetAppBack;
export default {
  namespaced: true,
  state: {
    province_th_list: [],
    maintenance_data: {},
    popup_data: {},
    notification_list: [],
    free_delivery_status: { status: false },
  },
  mutations: {
    resetState(state) {
      state.province_th_list = [];
      state.maintenance_data = {};
      state.popup_data = {};
      state.notification_list = [];
      state.free_delivery_status = { status: false };
    },
    getSubdistrictTH(state, data) {
      state.province_th_list = data;
    },
    getMaintenanceData(state, data) {
      state.maintenance_data = data;
    },
    getPopupData(state, data) {
      state.popup_data = data;
    },
    getNotificationList(state, data) {
      state.notification_list = data;
    },
    deleteNotificationLog(state, id) {
      let index = state.notification_list.findIndex(
        (val) => val.notification_inbox_id == id
      );
      state.notification_list.splice(index, 1);
    },
    getFreedeliveryStatus(state, status) {
      state.free_delivery_status = { status: status };
    },
  },
  actions: {
    async editBackListKeyword({}, payload) {
      // console.log(url)
      let form = {
        blacklist_area_keyword: payload.keyword,
      };
      let url = `/api/v1/${payload.province}/edit/BlacklistArea/${
        payload.keyword_id
      }`;
      return globalAxios
        .put(url, form)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async createBackListKeyword({}, payload) {
      // console.log(url)
      let form = {
        blacklist_area_keyword: payload.keyword,
      };
      let url = `/api/v1/${payload.province}/create/BlacklistArea`;
      return globalAxios
        .post(url, form)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async removeBackListKeyword({}, payload) {
      let url = `/api/v1/${payload.province}/delete/BlacklistArea/${
        payload.keyword_id
      }`;
      return globalAxios
        .delete(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async getBackListKeywordList({}, payload) {
      // console.log(url)
      let url = `/api/v1/${payload.province}/show/BlacklistArea?page_size=${
        payload.page_size
      }&current_page=${payload.page}`;
      return globalAxios
        .get(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async editFreeDeliveryStatus(
      { rootState, dispatch, commit },
      { province_id, form }
    ) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_editFreeDeliveryStatus +
        province_id;

      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async getFreeDeliveryStatus({ rootState, dispatch, commit }, province_id) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_getFreeDeliveryStatus +
        province_id;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getFreedeliveryStatus", res.province_free_delivery);
        return true;
      }
    },
    async deleteNotificationLog({ dispatch, commit }, ID) {
      let url = backendVersion.version + "/deleteInbox/" + ID;
      let res = await dispatch("fetchGeneral/coreInstanceDeleteData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("deleteNotificationLog", ID);
      }
      return res.msg ? res.msg : false;
    },
    async getNotificationList({ dispatch, commit }) {
      let url = backendVersion.version + "/getAllInbox";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
      } else {
        commit("getNotificationList", res.data);
      }
      return res;
    },
    async editNotificationContent({ dispatch, commit }, form) {
      let url = backendVersion.version + "/editInbox";
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async editNotificationBlog({ dispatch, commit }, form) {
      let url = backendVersion.version + "/editInbox";
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async sendNotification({ dispatch, commit }, form) {
      let url = backendVersion.version + "/createInbox";
      let res = await dispatch(
        "fetchGeneral/coreInstancePostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res.msg;
      }
    },
    async updatePopupData(
      { rootState, dispatch, commit },
      { province_id, form }
    ) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_updatePopupData + province_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getPopupData", res);
        return true;
      }
    },
    async getPopupData({ rootState, dispatch, commit }, province_id) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_getPopupData + province_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getPopupData", res);
        return true;
      }
    },
    async updateMaintenaceData({ dispatch, commit }, form) {
      let url = backendVersion.version + "/fix_maintenance";
      let res = await dispatch(
        "fetchGeneral/coreInstancePutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getMaintenanceData", res);
        return true;
      }
    },
    async getMaintenanceData({ dispatch, commit }) {
      let url = backendVersion.version + "/fix_maintenance";
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getMaintenanceData", res);
        return true;
      }
    },
    async updateENSubdistrict({ rootState, dispatch }, form) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_updateENSubdistrict +
        form.sub_district_province_id +
        "/" +
        form.sub_district_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return true;
      }
    },
    async getSubdistrictTH({ rootState, dispatch, commit }, province_id) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_getSubdistrictTH + province_id;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("getSubdistrictTH", res);
        return res;
      }
    },
    async changeStorePopular({ rootState, dispatch }, form) {
      let url =
        rootState.api_urls.fetchFoodSetAppBack_changeStorePopular +
        form.store_id;
      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res.msg;
      }
    },
    async fetchPaymentMethodList({ rootState, dispatch }) {
       let url = '/api/v1/WeservePatmentOfmethod'
      return globalAxios
        .get(url)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    async changePaymentMethodStatus({ rootState, dispatch }, payload) {
      let url = `/api/v1/WeservePatmentOfmethod/${payload.service_on_use_id}`;
      let form = JSON.parse(JSON.stringify(payload))
      delete form.service_on_use_id;
      return globalAxios
        .put(url, form)
        .then((res) => {
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
  },
  getters: {
    NotificationList(state) {
      return state.notification_list;
    },
  },
};
